import React from 'react'
import InfoIcon from '@material-ui/icons/Info';
import { Button, styled, Typography } from '@material-ui/core'
import { connect } from 'react-redux';
import * as coreSelectors from 'core/selectors';
import { useHistory, useLocation } from 'react-router-dom';
import { getCurrentScreen } from 'utils';

const PageLabelContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  '& > *': {
    marginRight: theme.spacing(1),
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row'
  }
}))

function PageLabel({ user, availableScreens }) {
  const history = useHistory()
  const location = useLocation()
  const screenName = getCurrentScreen(availableScreens, location.pathname)
  const screenObj = availableScreens.find(s => s.name === screenName) || { label: screenName.charAt(0).toUpperCase() + screenName.slice(1) }
  const isPastDue = user.userAccountRoles.filter(role => role?.isAccountPastDue === 'Y').length > 0;
  return (
    <PageLabelContainer>
      <Typography
        variant="body2"
        style={{ fontSize: 28, fontFamily: 'Sofia-bold' }}>
        {screenObj.label}
      </Typography>
      {isPastDue && <Button variant="outlined" style={{ marginLeft: 10, marginTop: 5, color: '#FF0000', borderColor: '#FF0000', textTransform: 'none', fontFamily: 'Sofia-bold' }}
        onClick={() => { history.push('billing') }} startIcon={<InfoIcon />}>Your account has an outstanding balance that is past due</Button>}
      {screenName === 'dashboard' && <Button variant="outlined" style={{ marginLeft: 10, marginTop: 5, color: '#7f2062', borderColor: '#7f2062', textTransform: 'none', fontFamily: 'Sofia-bold' }}
        onClick={() => { window.open("https://info.ruby.com/shareruby") }} startIcon={<InfoIcon />}>Refer and Save</Button>}

    </PageLabelContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: coreSelectors.getUser(state),
    availableScreens: coreSelectors.getAvailableScreens(state),
  });
};

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(PageLabel);
